export function formatName(name: string): string {
  return (
    name.charAt(0).toUpperCase() +
    name
      .slice(1)
      .split(/(?=[A-Z][a-z])/)
      .join(' ')
  );
}

export const isUuid = (text: string): boolean => {
  const uuidRegex =
    /^[0-9a-fA-F]{8}-[0-9a-fA-F]{4}-[0-9a-fA-F]{4}-[0-9a-fA-F]{4}-[0-9a-fA-F]{12}$/;
  return uuidRegex.test(text);
};
